import axios from '../utils/axios';

export default function activateSeekerSubscriptions(adminId,data) {
    return (
        axios.post('/admin/' + adminId + '/manageSeekerSubscriptions/v2/admin/activateSubscription', data )
    )
}
